import React, { ReactElement } from 'react';
import './Info.scss';

const Ru: React.FC = (): ReactElement => {
  return (
    <div className="Ru ruleset-wrapper">
      <ol>
        <li>
          С помощью этой формы Кассы здоровья обрабатывает личные данные
          человека, загружающего изображение. Личными данными считаются только
          изображение людей, идентифицируемых на фотографиях. Загрузка
          изображения является добровольным.
        </li>
        <li>
          Отправителю сообщения разрешено загружать только те фотографии, на
          которых изображен он сам. Если на фотографии изображен другой человек,
          загрузчик изображения обязан убедиться, что изображенный на фотографии
          человек дал согласие на его использование в фотоколлаже для кампании
          Кассы здоровья 2026 года.
        </li>
        <li>
          Загрузчик изображения обладает авторскими правами на загруженное
          изображение или имеет письменное согласие автора изображения на
          передачу изображения в Кассу здоровья.
        </li>
        <li>
          Изображения будут храниться до 31.03.2027. После этого Касса здоровья
          уничтожит собранные изображения.
        </li>
        <li>
          Загрузивший изображение имеет право отозвать свое согласие в любое
          время без ущерба для законности работы с изображением, проведенной до
          отзыва. Для отзыва согласия необходимо сохранить созданное и
          загруженное вами сообщение с напоминанием. Чтобы отозвать свое
          согласие, нужно связаться с Кассой здоровья по адресу электронной
          почты{' '}
          <a href="mailto:soeluuring@tervisekassa.ee">
            soeluuring@tervisekassa.ee{' '}
          </a>{' '}
          и отправить вместе с запросом напоминание с изображением, которое Вы
          хотите отозвать.
        </li>
        <li>
          При возникновении каких-либо вопросов можно связаться с Кассой
          здоровья по адресу электронной почты{' '}
          <a href="mailto:soeluuring@tervisekassa.ee">
            soeluuring@tervisekassa.ee
          </a>
          .
        </li>
        <li>
          Изображение будет использовано только в фотоколлаже кампании Кассы
          здоровья 2026 года при условии отдельного согласия на это,
          подтвержденного <a href="/">ЗДЕСЬ</a> до 31.03.2027.
        </li>
      </ol>
    </div>
  );
};

export default Ru;
